import React from "react";
import "./Roadmap_Section.css";

import LeftImage from "../../../Assets/Home/Roadmap_Section/final.png";
import Icon1 from "../../../Assets/Home/Roadmap_Section/1.png";
import Icon2 from "../../../Assets/Home/Roadmap_Section/2.png";
import Icon3 from "../../../Assets/Home/Roadmap_Section/3.png";
import Brush from "../../../Assets/Home/Roadmap_Section/Tag.png";

export default function Roadmap() {
  return (
    <section className="roadmap-wrapper">

      <div className="left-image-box">
        <img src={LeftImage} alt="" />
      </div>

      <div className="right-content">

        <h2 className="roadmap-title">Innovation Roadmap</h2>
        <img src={Brush} className="roadmap-brush" alt="" />

        <div className="steps">

          <div className="step-card">
            <div className="step-left">
              <img src={Icon1} alt="" className="step-icon" />
              <div>
                <h4 className="step-title">Current: Fulupo AI Storekeeper</h4>
                <p className="step-desc">
                 Store, Consumer and Delivery Partner
                </p>
              </div>
            </div>
            <span className="tag green">Q1 Live</span>
          </div>

          <div className="step-card">
            <div className="step-left">
              <img src={Icon2} alt="" className="step-icon" />
              <div>
                <h4 className="step-title">Next: Fulupo AI Vendors</h4>
                <p className="step-desc">
                 AI vendor mapping, AI purchase <br /> order trigger, etc.
                </p>
              </div> 
            </div>
            <span className="tag dark-green">Q1 2026</span>
          </div>

          <div className="step-card">
            <div className="step-left">
              <img src={Icon3} alt="" className="step-icon" />
              <div>
                <h4 className="step-title">Future: PRODUCER tech™</h4>
                <p className="step-desc">
                  Fully unmanned stores,<br /> autonomous 
                  operations
                </p>
              </div>
            </div>
            <span className="tag olive">Q3 2026</span>
          </div>

        </div>
      </div>
    </section>
  );
}
